import {useEffect, useState} from 'react';
import {usePaymentHistoryEntries} from '../queries/use-paginated-entries';
import {AddFunds} from '@app/drive/share-dialog/amount-add-form';

export function PaymentHistoryTable() {
  const [params, setParams] = useState<any>({});
  const {data, isLoading, refetch} = usePaymentHistoryEntries(params);
  const [openAddFunds, setOpenAddFunds] = useState(false);
  const windowParams = new URLSearchParams(window.location.search);
  const sessionId = windowParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      setOpenAddFunds(true);
    }
  }, [sessionId]);

  useEffect(() => {
    if (!openAddFunds) {
      refetch();
    }
  }, [isLoading, openAddFunds, refetch]);

  console.log('Payment History Data:', data);

  return (
    <>
      {openAddFunds ? (
        <AddFunds setOpen={setOpenAddFunds} sessionId={sessionId} />
      ) : (
        <div className="flex h-full flex-col">
          {/* Header */}
          <div className="flex h-60 items-center gap-20 border-b px-8 py-4 md:px-26">
            <h1 className="text-lg font-semibold">Payment History</h1>
            <div className="ml-auto">
              <button
                className="rounded bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark"
                onClick={() => setOpenAddFunds(true)}
              >
                Add Funds
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="stable-scrollbar relative flex-auto overflow-y-auto">
            <div className="p-16 text-center">
              {data && data.length > 0 ? (
                <div className="overflow-auto rounded-2xl shadow-lg mb-20">
                  <table className="w-full table-auto border-collapse border p-10">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="border-b px-14 py-10 text-center">
                          Date
                        </th>
                        <th className="border-b px-14 py-10 text-center">
                          Type
                        </th>
                        <th className="border-b px-14 py-10 text-center">
                          Operation
                        </th>
                        <th className="border-b px-14 py-10 text-center">
                          Creator
                        </th>
                        <th className="border-b px-14 py-10 text-center">
                          Amount
                        </th>
                        <th className="border-b px-14 py-10 text-left">
                          Note
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((entry: any, index: number) => (
                        <tr
                          key={entry.id || index}
                          className="hover:bg-gray-50 border-b"
                        >
                          <td className="px-14 py-10 text-center text-sm text-gray-900">
                            {entry.date ? new Date(entry.date).toLocaleDateString() : 'N/A'}
                          </td>
                          <td className="px-14 py-10 text-center text-sm">
                            <span
                              className={`inline-flex px-8 py-4 text-xs font-semibold rounded-full ${
                                entry.type === 'Credit'
                                  ? 'bg-green-100 text-green-800'
                                  : 'bg-red-100 text-red-800'
                              }`}
                            >
                              {entry.type}
                            </span>
                          </td>
                          <td className="px-14 py-10 text-center text-sm text-gray-900">
                            {entry.operation || 'N/A'}
                          </td>
                          <td className="px-14 py-10 text-center text-sm text-gray-900">
                            {entry.creator || 'System'}
                          </td>
                          <td className="px-14 py-10 text-center text-sm font-medium">
                            <span
                              className={
                                entry.type === 'Credit'
                                  ? 'text-green-600'
                                  : 'text-red-600'
                              }
                            >
                              {entry.type === 'Credit' ? '+' : '-'}£{entry.amount}
                            </span>
                          </td>
                          <td className="px-14 py-10 text-left text-sm text-gray-900">
                            {entry.note || 'No note'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="mt-40 text-center">
                  <div className="mb-24 flex h-128 items-center justify-center">
                    <svg
                      className="h-32 w-32 text-gray-300"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </div>
                  <div className="mb-2 text-lg text-main">No payments</div>
                  <div className="text-base text-muted">
                    You have not added any payments yet
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
